import React from 'react';
import { useSelector } from 'react-redux';
import ErrorPage from '@sunbit-dev/ui/src/components/card-apply/pages/error/ErrorPage';
import { selectError } from '../selectors';
import { PrivacyOptions } from '@sunbit-dev/common/enums/Datadog';

const ErrorPageContainer: React.FC = () => {
  const error = useSelector(selectError);

  const displayTxt = typeof error.description === 'function' ? error.description(error.payload) : error.description;

  const errorProps = {
    errorDescription: displayTxt,
  };
  return <ErrorPage data-dd-privacy={PrivacyOptions.MaskUserInput} {...errorProps} />;
};

export default ErrorPageContainer;
